<template>
    <div v-if="!editMode" class="innerPadding30 margin30Top description" style="padding-bottom:20px; border: 1px solid #000;">
        <div class="oldTableContainer width100 fontRoboto">
            Erfasse hier deine Inhalte wie Beiträge, Fotos und Social Media-Posts
            <hr/>
            <div class="textAlignRight buttonBlockContainerRight">
                <button v-on:click="enterEditMode" class="btn btn-white teaserButton">Weiter</button>
            </div>
        </div>
    </div>
	<div v-else class="border-color1" style="margin-top:30px;padding-bottom:20px">
	    <div v-if="tabSize == 5" class="oldTabOuterContainer tabOuterContainer clearfix">
            <div class="oldTabContainerQuarter clearfix">
                <div v-bind:class="[{ active: isActive(0) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(0, $event)">
                    <span>{{ getLabel(0) }}</span>
                </div>
                <div v-bind:class="[{ active: isActive(1) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(1, $event)">
                    <span>{{ getLabel(1) }}</span>
                </div>
            </div>
            <div class="oldTabContainerQuarter clearfix">
                <div v-bind:class="[{ active: isActive(2) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(2, $event)">
                    <span>{{ getLabel(2) }}</span>
                </div>
                <div v-bind:class="[{ active: isActive(3) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(3, $event)">
                    <span>{{ getLabel(3) }}</span>
                </div>
            </div>
            <div class="oldTabContainerQuarter clearfix">
                <div v-bind:class="[{ active: isActive(4) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(4, $event)">
                    <span>{{ getLabel(4) }}</span>
                </div>
            </div>
        </div>
        <div v-if="tabSize == 4" class="oldTabOuterContainer tabOuterContainer clearfix">
            <div class="oldTabContainerQuarter clearfix">
                <div v-bind:class="[{ active: isActive(0) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(0, $event)">
                    <span>{{ getLabel(0) }}</span>
                </div>
                <div v-bind:class="[{ active: isActive(1) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(1, $event)">
                    <span>{{ getLabel(1) }}</span>
                </div>
            </div>
            <div class="oldTabContainerQuarter clearfix">
                <div v-bind:class="[{ active: isActive(2) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(2, $event)">
                    <span>{{ getLabel(2) }}</span>
                </div>
                <div v-bind:class="[{ active: isActive(3) }, 'tabEntry', 'oldTabQuarter']" v-on:click="selectTab(3, $event)">
                    <span>{{ getLabel(3) }}</span>
                </div>
            </div>
        </div>
        <div v-if="tabSize == 3" class="oldTabOuterContainer tabOuterContainer clearfix">
            <div class="oldTabContainerThird first clearfix">
                <div v-bind:class="[{ active: isActive(0) }, 'tabEntry', 'oldTabThird']" v-on:click="selectTab(0, $event)">
                    <span>{{ getLabel(0) }}</span>
                </div>
                <div v-bind:class="[{ active: isActive(1) }, 'tabEntry', 'oldTabThird']" v-on:click="selectTab(1, $event)">
                    <span>{{ getLabel(1) }}</span>
                </div>
            </div>
            <div class="oldTabContainerThird">
                <div v-bind:class="[{ active: isActive(2) }, 'tabEntry', 'oldTabThird']" v-on:click="selectTab(2, $event)">
                    <span>{{ getLabel(2) }}</span>
                </div>
            </div>
        </div>
        <div v-if="tabSize == 2" class="oldTabOuterContainer tabOuterContainer clearfix">
            <div class="oldTabContainerHalf clearfix">
                <div v-bind:class="[{ active: isActive(0) }, 'tabEntry', 'oldTabHalf']" v-on:click="selectTab(0, $event)">
                    <span>{{ getLabel(0) }}</span>
                </div>
                <div v-bind:class="[{ active: isActive(1) }, 'tabEntry', 'oldTabHalf']" v-on:click="selectTab(1, $event)">
                    <span>{{ getLabel(1) }}</span>
                </div>
            </div>
        </div>
        <div v-if="tabSize == 1" class="oldTabOuterContainer tabOuterContainer clearfix">
            <div class="oldTabContainerSingle clearfix">
                <div v-bind:class="[{ active: isActive(0) }, 'tabEntry', 'oldTabSingle']" v-on:click="selectTab(0, $event)">
                    <span>{{ getLabel(0) }}</span>
                </div>
            </div>
        </div>
        <userContentReport v-if="isActive('report')" v-on:cancel="leaveEditMode" :project="project" :contentkey="contentkey"></userContentReport>
        <userContentEmbeds v-if="isActive('embeds')" v-on:cancel="leaveEditMode" :project="project" :contentkey="contentkey"></userContentEmbeds>
        <userContentLinks v-if="isActive('links')" v-on:cancel="leaveEditMode" :project="project" :contentkey="contentkey"></userContentLinks>
        <userContentImages v-if="isActive('images')" v-on:cancel="leaveEditMode" :project="project" :contentkey="contentkey"></userContentImages>
        <userContentReply v-if="isActive('reply')" v-on:cancel="leaveEditMode" :project="project" :contentkey="contentkey" :replycontentkey="replycontentkey"></userContentReply>
	</div>
</template>

<script>
	import UserContentReport from './UserContentReport.vue'
	import UserContentLinks from './UserContentLinks.vue'
	import UserContentEmbeds from './UserContentEmbeds.vue'
	import UserContentImages from './UserContentImages.vue'
	import UserContentReply from './UserContentReply.vue'
	export default {
		name: 'userContentEditor',
		props: {
            tabs: Array,
            project: String,
            contentkey: String,
            replycontentkey: String
        },
        data: function() {
        	return {
                editMode : false,
                tabSize : 0,
                activeTab : 0,
                label : null
        	}
        },
        created: function() {
            if (this.contentkey || this.replycontentkey) {
                this.editMode = true;
                if(this.contentkey.lastIndexOf("embedded-", 0) === 0) {
                	this.tabs.pop();
                	this.tabs.push('embeds');
                }
            } else {
	            if(this.tabs.length > 0) {
	            	if(this.tabs.includes('links')) {
	            		this.tabs.unshift('embeds');
	            	}
	            }
            }
            this.tabSize = this.tabs.length;
        },
        methods: {
        	enterEditMode: function() {
        		this.editMode = true;
            },
            leaveEditMode: function() {
                this.editMode = false;
                if (this.contentkey || this.replycontentkey) {
                        window.location.href = '/project/' + this.project + '/content.html';
                }
            },
            selectTab: function(tab, event) {
                if (typeof tab === 'string') {
                    this.activeTab = this.tabs.indexOf(tab);
                } else if (typeof tab === 'number') {
                    this.activeTab = tab;
                }
            },
            isActive: function(tab) {
                if (typeof tab === 'string') {
                    return (this.tabs.indexOf(tab) === this.activeTab);
                } else if (typeof tab === 'number') {
                    return (tab === this.activeTab);
                }
            },
            getLabel: function(tab) {
                if (typeof tab === 'string') {
                    switch(tab) {
                        case 'report':
                            return 'Berichte';
                        case 'links':
                            return 'Links/Videos';
                        case 'embeds':
                            return 'Embed-Codes';
                        case 'images':
                            return 'Bilder';
                        case 'receipe':
                            return 'Rezepte';
                        case 'reply':
                            return 'Antwort';
                    }
                } else if (typeof tab === 'number') {
                    switch(this.tabs[tab]) {
                        case 'report':
                            return 'Berichte';
                        case 'links':
                            return 'Links/Videos';
                        case 'embeds':
                            return 'Embed-Codes';
                        case 'images':
                            return 'Bilder';
                        case 'receipe':
                            return 'Rezepte';
                        case 'reply':
                            return 'Antwort';
                    }
                }
            }
        },
        components: { UserContentReport, UserContentLinks, UserContentImages, UserContentReply, UserContentEmbeds }
	}
</script>


// WEBPACK FOOTER //
// UserContentEditor.vue?421131ea